import React from "react";
import { makeStyles } from "@material-ui/core";
import Dialog, { DialogProps } from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";

export interface CustomDialogProps extends DialogProps {
  cutHorizPadding?: boolean;
  onClose: (...props: any[]) => void;
}

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    padding: "2rem",
    overflow: "auto",
  },
  cutHorizPadding: {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  icon: {
    cursor: "pointer",
    position: "absolute",
    right: "2rem",
    top: "2rem",
    zIndex: 100,
  },
});

const CustomDialog: React.FC<CustomDialogProps> = (props) => {
  const { children, className, cutHorizPadding, fullScreen, fullWidth, maxWidth, onClose, open, ...restProps } = props;
  const classes = useStyles(props);

  return (
    <Dialog
      className={className}
      style={fullScreen ? { margin: 32 } : undefined}
      fullScreen={fullScreen}
      open={open}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      onClose={onClose}
      {...restProps}
    >
      <CloseIcon
        className={[classes.icon, className].join(" ")}
        onClick={() => {
          onClose();
        }}
      />
      <div className={[classes.container, cutHorizPadding && classes.cutHorizPadding].join(" ")}>{children}</div>
    </Dialog>
  );
};

export default CustomDialog;
